module.exports = __webpack_public_path__ + "static/media/drag.f5766bc1.svg";